export var LEGACY_CONVERSION_PATH = "/asg/Api/V1/Policies/legacy-conversions";
export var LEGACY_CONVERSION_BATCH_PATH = "".concat(LEGACY_CONVERSION_PATH, "/batch");
export var LEGACY_CONVERSION_MAX_CODES = 500;
export var LEGACY_CONVERSION_DEFAULT_OPTIONS = {
    reprintCertificates: true,
};
export var LEGACY_CONVERSION_RESULT_QUOTE_ID_FIELD = "quoteId";
export var LEGACY_CONVERSION_RESULT_PRODUCT_ID_FIELD = "productId";
export var LEGACY_CONVERSION_RUN_TEXT = {
    alreadyConverted: "La póliza ya está convertida.",
    inBatch: "La póliza está dentro de un lote de conversión en curso.",
    taskFailed: "No se pudo convertir la póliza.",
    missingResult: "La póliza se convirtió, pero no se pudo abrir la cotización nueva.",
};
export var CONTROL_CENTER_ROUTE = "/admin/control-center";
export var POLICY_ROUTE_BASE = "/confirmationForm";
export var LEGACY_CONVERSION_TEXT = {
    queuedTitle: "Conversión solicitada",
    queuedBatchTitle: "Lote de conversión solicitado",
    queuedDescription: function (shortId) {
        return "Pod\u00E9s seguir el avance de la tarea #".concat(shortId, " en el Centro de control.");
    },
    alreadyConvertedTitle: "La póliza ya está convertida",
    alreadyConvertedDescription: "No se volvió a pedir la conversión.",
    inBatchTitle: "La póliza está dentro de un lote en curso",
    inBatchDescription: "Esperá a que termine el lote antes de convertirla de nuevo.",
    tooManyCodes: function (max) {
        return "No se pueden convertir m\u00E1s de ".concat(max, " p\u00F3lizas a la vez.");
    },
    viewTask: "Ver en Centro de control",
    viewBatch: "Ver lote",
    viewPolicy: "Ver póliza",
};
